"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ExportCompetencyAssignmentsCsvHandlerEvent () {
        return ExportCompetencyAssignmentsCsvHandlerEvent;
    },
    get ExportGoalsCsvHandlerEvent () {
        return ExportGoalsCsvHandlerEvent;
    },
    get ExportGoalsCsvTaskRef () {
        return ExportGoalsCsvTaskRef;
    },
    get GenerateRubricHandlerEvent () {
        return GenerateRubricHandlerEvent;
    },
    get ImportFieldHistoryHandlerEvent () {
        return ImportFieldHistoryHandlerEvent;
    },
    get ReviewCycleCalculateHandlerEvent () {
        return ReviewCycleCalculateHandlerEvent;
    },
    get ScoreReviewCycleHandlerEvent () {
        return ScoreReviewCycleHandlerEvent;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _competencyassignments = require("../competency-assignments");
const ReviewCycleCalculateHandlerEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    reviewCycleId: _utilsisomorphic.transformObjectId,
    actions: _zod.z.enum([
        "unassigned-reports",
        "status"
    ]).array()
});
const GenerateRubricHandlerEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    formId: _utilsisomorphic.transformObjectId,
    userId: _utilsisomorphic.transformObjectId.optional(),
    formPurpose: _zod.z.string().optional(),
    persist: _zod.z.boolean().optional()
});
const ScoreReviewCycleHandlerEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    reviewCycleId: _utilsisomorphic.transformObjectId
});
const ImportFieldHistoryHandlerEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    taskId: _utilsisomorphic.transformObjectId
});
const ExportCompetencyAssignmentsCsvHandlerEvent = _competencyassignments.ExportCompetencyAssignmentsCsvQueryBase.extend({
    companyId: _utilsisomorphic.transformObjectId,
    userId: _utilsisomorphic.transformObjectId,
    taskId: _utilsisomorphic.transformObjectId,
    levelGap: _zod.z.array(_models.CompetencyLevelGapSchema).optional(),
    competencyIds: _zod.z.array(_utilsisomorphic.transformObjectId).optional(),
    roleIds: _zod.z.array(_utilsisomorphic.transformObjectId).optional()
});
const ExportGoalsCsvHandlerEvent = _zod.z.object({
    companyId: _utilsisomorphic.transformObjectId,
    userId: _utilsisomorphic.transformObjectId,
    taskId: _utilsisomorphic.transformObjectId,
    pipeline: _zod.z.string()
});
const ExportGoalsCsvTaskRef = ExportGoalsCsvHandlerEvent.pick({
    companyId: true,
    taskId: true
});
